import { render, staticRenderFns } from "./StatsOverdueInfo.vue?vue&type=template&id=84576688&"
import script from "./StatsOverdueInfo.vue?vue&type=script&lang=js&"
export * from "./StatsOverdueInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports